import React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';

// 3rd Party
import ExecutionEnvironment from 'exenv';
import Collapse from 'react-collapse';
import { StickyContainer, Sticky } from 'react-sticky';

const mapStateToProps = state => ({ headerIsPinned: state.headerIsPinned });

class References extends React.Component {
  constructor(props) {
    super(props);

    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    const clientsTop = document.querySelector('section.references .wrap').getBoundingClientRect().top,
      scrollTop = document.body.scrollTop,
      scrollBottomClients = scrollTop - clientsTop + document.body.clientHeight;

    let percent = scrollBottomClients / (document.body.clientHeight + document.querySelector('section.references .wrap').clientHeight );

    if (percent >= 2.5) {
      percent = percent * 0.9;
    }

    if (percent >= 3) {
      percent = 3;
    }

    for (let count = 1; count <= 3; count++) {
      const width = document.querySelector(`section.references .row-${count} .inner`).clientWidth,
        maxScrollLeft = width - document.querySelector('section.references .wrap').clientWidth,
        scrollTo = (-maxScrollLeft * percent) / 3;

      document.querySelector(`section.references .row-${count}`).style.transform = `translate3d(${scrollTo}px,0,0)`;
      document.querySelector(`section.references .row-${count}`).style.mozTransform = `translate3d(${scrollTo}px,0,0)`;
      document.querySelector(`section.references .row-${count}`).style.webkitTransform = `translate3d(${scrollTo}px,0,0)`;
      document.querySelector(`section.references .row-${count}`).style.msTransform = `translate3d(${scrollTo}px,0,0)`;
    }
  }

  componentDidMount() {
    if (ExecutionEnvironment.canUseDOM) {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    if (ExecutionEnvironment.canUseDOM) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  render() {
    return (
      <section className="references">
        <Router>
          <div>
            <div className="wrap">
              <div className="row row-1">
                <div className="inner">
                  {this.props.content.row1.map((image, index) =>
                    <img key={index} src={`${require(`../../../public/content/assets/${image}`)}`} />
                  )}
                  {this.props.content.row1.map((image, index) =>
                    <img key={index} src={`${require(`../../../public/content/assets/${image}`)}`} />
                  )}
                </div>
              </div>
              <div className="row row-2">
                <div className="inner">
                  {this.props.content.row2.map((image, index) =>
                    <img key={index} src={`${require(`../../../public/content/assets/${image}`)}`} />
                  )}
                  {this.props.content.row2.map((image, index) =>
                    <img key={index} src={`${require(`../../../public/content/assets/${image}`)}`} />
                  )}
                </div>
              </div>
              <div className="row row-3">
                <div className="inner">
                  {this.props.content.row3.map((image, index) =>
                    <img key={index} src={`${require(`../../../public/content/assets/${image}`)}`} />
                  )}
                  {this.props.content.row3.map((image, index) =>
                    <img key={index} src={`${require(`../../../public/content/assets/${image}`)}`} />
                  )}
                </div>
              </div>
            </div>
            <Route path={'/referenzen'} children={({ match }) => (
              <StickyContainer>
                <div>
                  <Sticky topOffset={this.props.headerIsPinned ? -30 : -30} stickyStyle={this.props.headerIsPinned ? { marginTop: 140, zIndex: 10 } : { marginTop: 30, zIndex: 10 }} isActive={match}>
                    <Link to={match ? '/' : '/referenzen'} className={match ? 'read-more active' : 'read-more'}>
                      <svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 100 100">
                        <g>
                          <path fill="#8e8e8e" d="M50,5A45,45,0,1,0,95,50,45,45,0,0,0,50,5ZM77,54.75H54.75V77a4.76,4.76,0,1,1-9.5,0V54.75H23a4.76,4.76,0,1,1,0-9.5H45.25V23a4.76,4.76,0,1,1,9.5,0V45.25H77a4.76,4.76,0,1,1,0,9.5Z"/>
                        </g>
                      </svg>
                    </Link>
                  </Sticky>
                  <Collapse isOpened={match} className="references-content">
                    {this.props.content.text.map((item, index) =>
                      <article key={index} className="clients">
                        <h2>{item.heading}</h2>
                        <div className="content">
                          <p dangerouslySetInnerHTML={{ __html: item.text }} />
                        </div>
                      </article>
                    )}
                  </Collapse>
                </div>
              </StickyContainer>
            )} />
          </div>
        </Router>
      </section>
    );
  }
}

export default connect(mapStateToProps)(References);


// WEBPACK FOOTER //
// ./src/sections/references/references.jsx